'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MP4Icon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MP4Icon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Video-File-Camera--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Video File Camera Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="M21.207 4.5a1 1 0 0 1 0.293 0.707V22.5a1 1 0 0 1 -1 1h-17a1 1 0 0 1 -1 -1v-21a1 1 0 0 1 1 -1h13.293a1 1 0 0 1 0.707 0.293Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M16.577 11.542 13.5 13v-1.5a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1V15l3.077 1.459a0.62 0.62 0 0 0 0.923 -0.616v-3.686a0.619 0.619 0 0 0 -0.923 -0.615Z"
          fill="none"
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

MP4Icon.propTypes = {
  sx: PropTypes.object
}
